import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';

export default function Year(props) {
  const {
    year,
  } = props || {};
  return (
    <div {...ex('Year', props)}>
      {year}
    </div>
  );
}
